<template>
  <div>
    <center>
      <div class="lds-dual-ring text-center"></div>
    </center>
  </div>
</template>

<script>
import User from '../models/user';
import axios from 'axios';
import API from '../services/api.js';
import store from '../store/index.js'
export default {
  name: 'Login',
  data() {
    return {
      user: new User('', ''),
      id: this.$route.params.id,
      route: {},
      user_email: this.$route.query.user_email,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.loggedIn;
    }
  },
  created() {
    
      this.handleLogin()
    
  },
  methods: {
    async handleLogin(){
      await API.post(`/auth/login_ew/${this.id}`,{email: this.user_email})
        .then(({data,status}) => {
          if(status == 400){
            this.$notification["error"]({
                message: "Error",
                description: "Your email or password is wrong!",
              });
          }
          if (data.access_token) {
              localStorage.setItem('access_token', data.access_token);
              localStorage.setItem('refresh_token', data.refreshtoken);
              this.$store.dispatch('auth/getUser')
              .then(response => {
                store.commit('auth/getUserSuccess',response.data.profile)
                this.$router.push('/dashboard');
              })
            }
        })
    },
  }
};
</script>
<style scoped>
.lds-dual-ring {
  display: inline-block;
  width: 120px;
  height: 120px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 104px;
  height: 104px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>